// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eV","newsTag":"eV","dafalut":"eW","qishou":"eX","shangjia":"eY","shehui":"eZ","caiwu":"e0","piyao":"e1","suanfa":"e2","keji":"e3","lingshou":"e4","gongzuo":"e5"};